import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LOADING_STATUS } from "../../common/constants";
import { apiService } from "../../common/api/apiService";
import { API_ENDPOINTS } from "../../common/api/apiEndpoints";
import { formatDateToFinnish } from "../../common/misc";
import { RootState } from "../../app/store";

export interface SettlementReportRequest {
  accommodationId?: string;
  ownerId: string;
  bookingsStartDate: Date;
  bookingsEndDate: Date;
  isOwnerUser: boolean;
  noBookingsAfterEndDate: boolean;
}

export interface SettlementReportItem {
  settlementReportlines: SettlementReportItemLine[];
  extraBookingSettlementReportItems: SettlementReportItem[] | null;
}

export interface SettlementReportItemLine {
  bookingNumber: number;
  bookingId: string;
  bookingCreatedAt: string; // ISO 8601 date string
  startDate: string; // ISO 8601 date string
  endDate: string; // ISO 8601 date string
  bookingType: number;
  accommodationId?: string;
  productName: string;
  productNumber: string;
  payerFirstName: string;
  payerLastName: string;
  ownerPurchasePrice: number;
  ownerPurchasePriceVatP: number;
  ownerPurchasePriceVat: number;
  isMainProduct: boolean;
}
export interface SettlementReport {
  settlementReportItems: SettlementReportItem[];
}

export interface ReportsState {
  settlementReport: SettlementReport;
  settlementReportStatus:
    | LOADING_STATUS.IDLE
    | LOADING_STATUS.LOADING
    | LOADING_STATUS.FAILED;
}

const initialState: ReportsState = {
  settlementReport: {
    settlementReportItems: [],
  },
  settlementReportStatus: LOADING_STATUS.IDLE,
};

export const getSettlementReport = createAsyncThunk(
  "reports/getSettlementReport",
  async (
    settlementReportRequest: SettlementReportRequest,
    { rejectWithValue },
  ) => {
    try {
      const settlementReport = await apiService.post(
        API_ENDPOINTS.REPORTS.GET_SETTLEMENT_REPORT,
        settlementReportRequest,
      );
      return { settlementReport };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSettlementReport.pending, (state) => {
        state.settlementReportStatus = LOADING_STATUS.LOADING;
      })
      .addCase(getSettlementReport.fulfilled, (state, action) => {
        state.settlementReportStatus = LOADING_STATUS.IDLE;
        state.settlementReport = action.payload.settlementReport;
        // console.log(state.settlementReport);
      })
      .addCase(getSettlementReport.rejected, (state) => {
        state.settlementReportStatus = LOADING_STATUS.FAILED;
      });
  },
});

export const selectSettlementReportLoadingStatus = (state: RootState) =>
  state.reports.settlementReportStatus;
export const selectSettlementReport = (state: RootState) =>
  state.reports.settlementReport;

export default reportsSlice.reducer;
